import * as React from "react";
import {
  PriceResponse,
  AveragePrices,
  PriceClient,
  Channel,
} from "../api/ApiClient";
import Input from "../components/Input";

interface Props {
  price: PriceResponse;
  consumption: number;
  channel: Channel;
  onChangeConsumption(consumption: number): void;
}

interface State {
  averagePrices?: AveragePrices;
}

export default class PriceDescriptionModal extends React.PureComponent<
  Props,
  State
> {
  private priceClient: PriceClient = new PriceClient();
  state = {
    averagePrices: undefined,
  };

  async componentDidMount() {
    try {
      let averagePrices = await this.priceClient.average(
        this.props.consumption,
        this.props.channel
      );
      this.setState({ averagePrices });
    } catch (error) {
      console.debug("Failed to get average prices", error);
    }
  }

  render() {
    return (
      <div
        className="modal fade"
        id="prisModal"
        role="dialog"
        aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <p className="subheading">Rörligt avtal</p>
              <p className="copy">
                Prisberäkningen är baserad på din årsförbrukning (som vi
                uppskattat på din boendeform) och förra månadens inköpspris av
                100% fossilfri el. Detta inklusive elcertifikat(skatt) och
                avgifter som vi behöver betala samt vår låga månadsavgift.
                Alltihop inklusive moms presenteras som en uppskattad
                månadskostnad.
              </p>
              <p className="copy">
                Krånglig och tråkig info för en vanlig frisk människa. Tur att
                vi har en prisgaranti så du lugnt kan återgå till din
                favoritserie på Netflix när du är klar.
              </p>
              <div className="form-group">
                <label>Du kan ändra din årsförbrukning här:</label>
                <div className="input-group">
                  <input
                    value={this.props.consumption}
                    name="consumtion"
                    type="number"
                    step={100}
                    min={0}
                    max={50000}
                    className="form-control"
                    onChange={this.onChangeConsumption}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">kWh</span>
                  </div>
                </div>
              </div>
              <div className="textField">
                {this.props.price && this.props.price.month} kr / månad
              </div>
              <p
                className="subheading collapsed"
                data-toggle="collapse"
                data-target="#compare-table">
                Visa jämförelsepriser{" "}
                <i className="fa collapse-arrow" aria-hidden="true" />
              </p>
              <div id="compare-table" className="collapse">
                <div className="row">
                  <div className="col-7">
                    <p>2 000 kWh/år</p>
                  </div>
                  <div className="col-5">
                    <p className="pull-right">
                      {this.state.averagePrices &&
                        this.state.averagePrices.price2000}{" "}
                      öre/kWh
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-7">
                    <p>5 000 kWh/år</p>
                  </div>
                  <div className="col-5">
                    <p className="pull-right">
                      {this.state.averagePrices &&
                        this.state.averagePrices.price5000}{" "}
                      öre/kWh
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-7">
                    <p>20 000 kWh/år</p>
                  </div>
                  <div className="col-5">
                    <p className="pull-right">
                      {this.state.averagePrices &&
                        this.state.averagePrices.price20000}{" "}
                      öre/kWh
                    </p>
                  </div>
                </div>
                <p className="copy">
                  Jämförelsepriserna visar vad en kWh el skulle kostat förra
                  månaden för tre olika årsförbrukningar av el i elområde 3.
                </p>
              </div>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal">
                Klar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  onChangeConsumption = (event: React.ChangeEvent<HTMLInputElement>): void => {
    this.props.onChangeConsumption(parseInt(event.target.value));
  };
}
